import React from 'react';
import TasksListFunctional from './components/tasks-list-functional';
import './tasks-list.scss';

const TasksList = () => {
	return <TasksListFunctional />;
};

export default TasksList;
